const groupPrefix = createApiRoute(ApiModule.SUPPLIER, ApiAuthorization.EMPLOYEE)

export const apiSuppliersPriceLists = {
	fetchSupplierPriceList: async (
		id: number,
		page: number = 1,
		perPage: number = 25,
		search?: string,
	): Promise<IApiResponseModel<IPriceListModel[]>> => {
		const { data, meta } = await apiCommon<IPriceList[]>(`${groupPrefix}/${id}/price-list`, {
			method: 'GET',
			...createQuery({ page, perPage }, undefined, undefined, { query: search }),
		})

		return { data: data.map(d => PriceList(d)), meta }
	},

	importSupplierPriceList: async ({
		file,
		id,
		expirationDate,
		name,
	}: IImportSupplierPriceList): Promise<IApiResponseModel<any>> => {
		const formData = new FormData()
		formData.append('file', file)
		formData.append('expirationDate', formatDateToInput(expirationDate))
		formData.append('name', name)

		const { data, meta } = await apiCommon<any>(
			`${groupPrefix}/${id}/price-list`,
			{
				method: 'POST',
				body: formData,
			},
			'pl',
			true,
		)

		return { data, meta }
	},

	downloadSupplierPriceList: async (data: { supplierId: number; priceListId: number; fileName: string }) => {
		const response = (await apiCommon<Blob>(
			`${groupPrefix}/${data.supplierId}/price-list/${data.priceListId}/download`,
			{
				method: 'GET',
				responseType: 'blob',
			},
		)) as unknown as BlobPart

		const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
		const url = URL.createObjectURL(blob)
		const link = document.createElement('a')
		link.href = url
		link.setAttribute('download', `${data.fileName}.xlsx`)
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
		URL.revokeObjectURL(url)
	},

	editSupplierPriceList: async (objToSend: IEditSupplierPriceList): Promise<IEditSupplierPriceListResultModel> => {
		const formData = new FormData()
		if (objToSend.file) formData.append('file', objToSend.file)
		if (objToSend.expirationDate) formData.append('expirationDate', formatDateToInput(objToSend.expirationDate))
		if (objToSend.name) formData.append('name', objToSend.name)
		if (objToSend.isActive !== undefined) formData.append('isActive', String(objToSend.isActive))
		if (objToSend.force) formData.append('force', 'true')

		const response = await apiCommon<IEditSupplierPriceListResponse>(
			`${groupPrefix}/price-list/${objToSend.id}`,
			{
				method: 'POST',
				body: formData,
			},
			'pl',
			true,
		)

		const payload =
			typeof response === 'object' && response !== null && 'data' in response && response.data
				? response.data
				: (response as IEditSupplierPriceListResponse)

		return EditSupplierPriceListResult(payload)
	},

	deleteSupplierPriceList: async (id: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/price-list/${id}`, {
			method: 'DELETE',
		})
	},

	downloadSupplierPriceListTemplate: async (): Promise<void> => {
		const response = (await apiCommon<Blob>(`${groupPrefix}/price-list/template`, {
			method: 'GET',
			responseType: 'blob',
		})) as unknown as BlobPart

		const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

		const url = URL.createObjectURL(blob)

		const link = document.createElement('a')
		link.href = url
		link.setAttribute('download', 'szablon-cennika.xlsx')

		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)

		URL.revokeObjectURL(url)
	},
}
